import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

export default (lang) => {
  // Install VeeValidate rules and localization
  Object.keys(rules).forEach((rule) => {
    extend(rule, rules[rule]);
  });

  extend('isUrl', {
    validate: (value) => {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$', // fragment locator
        'i'
      );
      return !!pattern.test(value);
    },
    message: (fieldName) => {
      const message = {
        en: `The ${fieldName} field must be a valid URL`,
        es: `El campo ${fieldName} debe ser una URL válida`,
        pt: `O campo ${fieldName} deve ser um URL válido`,
        de: `Das Feld ${fieldName} muss eine gültige URL sein`
      };
      return message[lang];
    }
  });

  extend('password', {
    params: ['target'],
    validate(value, { target }) {
      return value === target;
    }
  });

  const code = lang === 'pt' ? 'pt_BR' : lang;
  import(`vee-validate/dist/locale/${code}.json`).then((locale) => {
    localize(code, locale);
  });

  Vue.component('ValidationObserver', ValidationObserver);
  Vue.component('ValidationProvider', ValidationProvider);
  //https://logaretm.github.io/vee-validate/
};
